export const sessionKeys = {
  all: ['session'] as const,
  current: () => [...sessionKeys.all, 'current'] as const,
};

export const viewAsKeys = {
  people: (search: string) => ['view-as', 'people', search] as const,
};

/** The session changes only on sign-in or sign-out — and every tab is told when it does. */
export const SESSION_STALE = 5 * 60 * 1000;

/** What the server keeps about the person can change elsewhere — another device, another tab, an admin — so a screen showing it reads it again after half a minute. */
export const DETAILS_STALE = 30 * 1000;
